import * as Luxon from 'luxon';

export const timezones = {
  "ACT": {
    "desc": "CST",
    "gmt": "GMT+9:30"
  },
  "AET": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Africa/Abidjan": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Accra": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Addis_Ababa": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "Africa/Algiers": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Africa/Asmara": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "Africa/Asmera": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "Africa/Bamako": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Bangui": {
    "desc": "WAT",
    "gmt": "GMT+1:00"
  },
  "Africa/Banjul": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Bissau": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Blantyre": {
    "desc": "CAT",
    "gmt": "GMT+2:00"
  },
  "Africa/Brazzaville": {
    "desc": "WAT",
    "gmt": "GMT+1:00"
  },
  "Africa/Bujumbura": {
    "desc": "CAT",
    "gmt": "GMT+2:00"
  },
  "Africa/Cairo": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Africa/Casablanca": {
    "desc": "WET",
    "gmt": "GMT+00:00"
  },
  "Africa/Ceuta": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Africa/Conakry": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Dakar": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Dar_es_Salaam": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "Africa/Djibouti": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "Africa/Douala": {
    "desc": "WAT",
    "gmt": "GMT+1:00"
  },
  "Africa/El_Aaiun": {
    "desc": "WET",
    "gmt": "GMT+00:00"
  },
  "Africa/Freetown": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Gaborone": {
    "desc": "CAT",
    "gmt": "GMT+2:00"
  },
  "Africa/Harare": {
    "desc": "CAT",
    "gmt": "GMT+2:00"
  },
  "Africa/Johannesburg": {
    "desc": "SAST",
    "gmt": "GMT+2:00"
  },
  "Africa/Kampala": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "Africa/Khartoum": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "Africa/Kigali": {
    "desc": "CAT",
    "gmt": "GMT+2:00"
  },
  "Africa/Kinshasa": {
    "desc": "WAT",
    "gmt": "GMT+1:00"
  },
  "Africa/Lagos": {
    "desc": "WAT",
    "gmt": "GMT+1:00"
  },
  "Africa/Libreville": {
    "desc": "WAT",
    "gmt": "GMT+1:00"
  },
  "Africa/Lome": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Luanda": {
    "desc": "WAT",
    "gmt": "GMT+1:00"
  },
  "Africa/Lubumbashi": {
    "desc": "CAT",
    "gmt": "GMT+2:00"
  },
  "Africa/Lusaka": {
    "desc": "CAT",
    "gmt": "GMT+2:00"
  },
  "Africa/Malabo": {
    "desc": "WAT",
    "gmt": "GMT+1:00"
  },
  "Africa/Maputo": {
    "desc": "CAT",
    "gmt": "GMT+2:00"
  },
  "Africa/Maseru": {
    "desc": "SAST",
    "gmt": "GMT+2:00"
  },
  "Africa/Mbabane": {
    "desc": "SAST",
    "gmt": "GMT+2:00"
  },
  "Africa/Mogadishu": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "Africa/Monrovia": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Nairobi": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "Africa/Ndjamena": {
    "desc": "WAT",
    "gmt": "GMT+1:00"
  },
  "Africa/Niamey": {
    "desc": "WAT",
    "gmt": "GMT+1:00"
  },
  "Africa/Nouakchott": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Ouagadougou": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Porto-Novo": {
    "desc": "WAT",
    "gmt": "GMT+1:00"
  },
  "Africa/Sao_Tome": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Timbuktu": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Africa/Tripoli": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Africa/Tunis": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Africa/Windhoek": {
    "desc": "WAT",
    "gmt": "GMT+1:00"
  },
  "AGT": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Adak": {
    "desc": "HAST",
    "gmt": "GMT-10:00"
  },
  "America/Anchorage": {
    "desc": "AKST",
    "gmt": "GMT-9:00"
  },
  "America/Anguilla": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Antigua": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Araguaina": {
    "desc": "BRT",
    "gmt": "GMT-3:00"
  },
  "America/Argentina/Buenos_Aires": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Argentina/Catamarca": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Argentina/ComodRivadavia": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Argentina/Cordoba": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Argentina/Jujuy": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Argentina/La_Rioja": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Argentina/Mendoza": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Argentina/Rio_Gallegos": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Argentina/Salta": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Argentina/San_Juan": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Argentina/San_Luis": {
    "desc": "WART",
    "gmt": "GMT-4:00"
  },
  "America/Argentina/Tucuman": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Argentina/Ushuaia": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Aruba": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Asuncion": {
    "desc": "PYT",
    "gmt": "GMT-4:00"
  },
  "America/Atikokan": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Atka": {
    "desc": "HAST",
    "gmt": "GMT-10:00"
  },
  "America/Bahia": {
    "desc": "BRT",
    "gmt": "GMT-3:00"
  },
  "America/Barbados": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Belem": {
    "desc": "BRT",
    "gmt": "GMT-3:00"
  },
  "America/Belize": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Blanc-Sablon": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Boa_Vista": {
    "desc": "AMT",
    "gmt": "GMT-4:00"
  },
  "America/Bogota": {
    "desc": "COT",
    "gmt": "GMT-5:00"
  },
  "America/Boise": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "America/Buenos_Aires": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Cambridge_Bay": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "America/Campo_Grande": {
    "desc": "AMT",
    "gmt": "GMT-4:00"
  },
  "America/Cancun": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Caracas": {
    "desc": "VET",
    "gmt": "GMT-4:30"
  },
  "America/Catamarca": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Cayenne": {
    "desc": "GFT",
    "gmt": "GMT-3:00"
  },
  "America/Cayman": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Chicago": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Chihuahua": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "America/Coral_Harbour": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Cordoba": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Costa_Rica": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Cuiaba": {
    "desc": "AMT",
    "gmt": "GMT-4:00"
  },
  "America/Curacao": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Danmarkshavn": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "America/Dawson": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "America/Dawson_Creek": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "America/Denver": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "America/Detroit": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Dominica": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Edmonton": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "America/Eirunepe": {
    "desc": "AMT",
    "gmt": "GMT-4:00"
  },
  "America/El_Salvador": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Ensenada": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "America/Fort_Wayne": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Fortaleza": {
    "desc": "BRT",
    "gmt": "GMT-3:00"
  },
  "America/Glace_Bay": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Godthab": {
    "desc": "WGT",
    "gmt": "GMT-3:00"
  },
  "America/Goose_Bay": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Grand_Turk": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Grenada": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Guadeloupe": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Guatemala": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Guayaquil": {
    "desc": "ECT",
    "gmt": "GMT-5:00"
  },
  "America/Guyana": {
    "desc": "GYT",
    "gmt": "GMT-4:00"
  },
  "America/Halifax": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Havana": {
    "desc": "CST",
    "gmt": "GMT-5:00"
  },
  "America/Hermosillo": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "America/Indiana/Indianapolis": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Indiana/Knox": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Indiana/Marengo": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Indiana/Petersburg": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Indiana/Tell_City": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Indiana/Vevay": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Indiana/Vincennes": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Indiana/Winamac": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Indianapolis": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Inuvik": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "America/Iqaluit": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Jamaica": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Jujuy": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Juneau": {
    "desc": "AKST",
    "gmt": "GMT-9:00"
  },
  "America/Kentucky/Louisville": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Kentucky/Monticello": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Knox_IN": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/La_Paz": {
    "desc": "BOT",
    "gmt": "GMT-4:00"
  },
  "America/Lima": {
    "desc": "PET",
    "gmt": "GMT-5:00"
  },
  "America/Los_Angeles": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "America/Louisville": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Maceio": {
    "desc": "BRT",
    "gmt": "GMT-3:00"
  },
  "America/Managua": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Manaus": {
    "desc": "AMT",
    "gmt": "GMT-4:00"
  },
  "America/Marigot": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Martinique": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Mazatlan": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "America/Mendoza": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Menominee": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Merida": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Mexico_City": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Miquelon": {
    "desc": "PMST",
    "gmt": "GMT-3:00"
  },
  "America/Moncton": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Monterrey": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Montevideo": {
    "desc": "UYT",
    "gmt": "GMT-3:00"
  },
  "America/Montreal": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Montserrat": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Nassau": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/New_York": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Nipigon": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Nome": {
    "desc": "AKST",
    "gmt": "GMT-9:00"
  },
  "America/Noronha": {
    "desc": "FNT",
    "gmt": "GMT-2:00"
  },
  "America/North_Dakota/Center": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/North_Dakota/New_Salem": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Panama": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Pangnirtung": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Paramaribo": {
    "desc": "SRT",
    "gmt": "GMT-3:00"
  },
  "America/Phoenix": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "America/Port_of_Spain": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Port-au-Prince": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Porto_Acre": {
    "desc": "AMT",
    "gmt": "GMT-4:00"
  },
  "America/Porto_Velho": {
    "desc": "AMT",
    "gmt": "GMT-4:00"
  },
  "America/Puerto_Rico": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Rainy_River": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Rankin_Inlet": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Recife": {
    "desc": "BRT",
    "gmt": "GMT-3:00"
  },
  "America/Regina": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Resolute": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Rio_Branco": {
    "desc": "AMT",
    "gmt": "GMT-4:00"
  },
  "America/Rosario": {
    "desc": "ART",
    "gmt": "GMT-3:00"
  },
  "America/Santarem": {
    "desc": "BRT",
    "gmt": "GMT-3:00"
  },
  "America/Santiago": {
    "desc": "CLT",
    "gmt": "GMT-4:00"
  },
  "America/Santo_Domingo": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Sao_Paulo": {
    "desc": "BRT",
    "gmt": "GMT-3:00"
  },
  "America/Scoresbysund": {
    "desc": "EGT",
    "gmt": "GMT-1:00"
  },
  "America/Shiprock": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "America/St_Barthelemy": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/St_Johns": {
    "desc": "NST",
    "gmt": "GMT-3:30"
  },
  "America/St_Kitts": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/St_Lucia": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/St_Thomas": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/St_Vincent": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Swift_Current": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Tegucigalpa": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Thule": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Thunder_Bay": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Tijuana": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "America/Toronto": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "America/Tortola": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Vancouver": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "America/Virgin": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "America/Whitehorse": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "America/Winnipeg": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "America/Yakutat": {
    "desc": "AKST",
    "gmt": "GMT-9:00"
  },
  "America/Yellowknife": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "Antarctica/Casey": {
    "desc": "WST",
    "gmt": "GMT+8:00"
  },
  "Antarctica/Davis": {
    "desc": "DAVT",
    "gmt": "GMT+7:00"
  },
  "Antarctica/DumontDUrville": {
    "desc": "DDUT",
    "gmt": "GMT+10:00"
  },
  "Antarctica/Mawson": {
    "desc": "MAWT",
    "gmt": "GMT+6:00"
  },
  "Antarctica/McMurdo": {
    "desc": "NZST",
    "gmt": "GMT+12:00"
  },
  "Antarctica/Palmer": {
    "desc": "CLT",
    "gmt": "GMT-4:00"
  },
  "Antarctica/Rothera": {
    "desc": "ROTT",
    "gmt": "GMT-3:00"
  },
  "Antarctica/South_Pole": {
    "desc": "NZST",
    "gmt": "GMT+12:00"
  },
  "Antarctica/Syowa": {
    "desc": "SYOT",
    "gmt": "GMT+3:00"
  },
  "Antarctica/Vostok": {
    "desc": "VOST",
    "gmt": "GMT+6:00"
  },
  "Arctic/Longyearbyen": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "ART": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Asia/Aden": {
    "desc": "AST",
    "gmt": "GMT+3:00"
  },
  "Asia/Almaty": {
    "desc": "ALMT",
    "gmt": "GMT+6:00"
  },
  "Asia/Amman": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Asia/Anadyr": {
    "desc": "ANAT",
    "gmt": "GMT+12:00"
  },
  "Asia/Aqtau": {
    "desc": "AQTT",
    "gmt": "GMT+5:00"
  },
  "Asia/Aqtobe": {
    "desc": "AQTT",
    "gmt": "GMT+5:00"
  },
  "Asia/Ashgabat": {
    "desc": "TMT",
    "gmt": "GMT+5:00"
  },
  "Asia/Ashkhabad": {
    "desc": "TMT",
    "gmt": "GMT+5:00"
  },
  "Asia/Baghdad": {
    "desc": "AST",
    "gmt": "GMT+3:00"
  },
  "Asia/Bahrain": {
    "desc": "AST",
    "gmt": "GMT+3:00"
  },
  "Asia/Baku": {
    "desc": "AZT",
    "gmt": "GMT+4:00"
  },
  "Asia/Bangkok": {
    "desc": "ICT",
    "gmt": "GMT+7:00"
  },
  "Asia/Beirut": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Asia/Bishkek": {
    "desc": "KGT",
    "gmt": "GMT+6:00"
  },
  "Asia/Brunei": {
    "desc": "BNT",
    "gmt": "GMT+8:00"
  },
  "Asia/Calcutta": {
    "desc": "IST",
    "gmt": "GMT+5:30"
  },
  "Asia/Choibalsan": {
    "desc": "CHOT",
    "gmt": "GMT+8:00"
  },
  "Asia/Chongqing": {
    "desc": "CST",
    "gmt": "GMT+8:00"
  },
  "Asia/Chungking": {
    "desc": "CST",
    "gmt": "GMT+8:00"
  },
  "Asia/Colombo": {
    "desc": "IST",
    "gmt": "GMT+5:30"
  },
  "Asia/Dacca": {
    "desc": "BDT",
    "gmt": "GMT+6:00"
  },
  "Asia/Damascus": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Asia/Dhaka": {
    "desc": "BDT",
    "gmt": "GMT+6:00"
  },
  "Asia/Dili": {
    "desc": "TLT",
    "gmt": "GMT+9:00"
  },
  "Asia/Dubai": {
    "desc": "GST",
    "gmt": "GMT+4:00"
  },
  "Asia/Dushanbe": {
    "desc": "TJT",
    "gmt": "GMT+5:00"
  },
  "Asia/Gaza": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Asia/Harbin": {
    "desc": "CST",
    "gmt": "GMT+8:00"
  },
  "Asia/Ho_Chi_Minh": {
    "desc": "ICT",
    "gmt": "GMT+7:00"
  },
  "Asia/Hong_Kong": {
    "desc": "HKT",
    "gmt": "GMT+8:00"
  },
  "Asia/Hovd": {
    "desc": "HOVT",
    "gmt": "GMT+7:00"
  },
  "Asia/Irkutsk": {
    "desc": "IRKT",
    "gmt": "GMT+8:00"
  },
  "Asia/Istanbul": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Asia/Jakarta": {
    "desc": "WIT",
    "gmt": "GMT+7:00"
  },
  "Asia/Jayapura": {
    "desc": "EIT",
    "gmt": "GMT+9:00"
  },
  "Asia/Jerusalem": {
    "desc": "IST",
    "gmt": "GMT+2:00"
  },
  "Asia/Kabul": {
    "desc": "AFT",
    "gmt": "GMT+4:30"
  },
  "Asia/Kamchatka": {
    "desc": "PETT",
    "gmt": "GMT+12:00"
  },
  "Asia/Karachi": {
    "desc": "PKT",
    "gmt": "GMT+5:00"
  },
  "Asia/Kashgar": {
    "desc": "CST",
    "gmt": "GMT+8:00"
  },
  "Asia/Kathmandu": {
    "desc": "NPT",
    "gmt": "GMT+5:45"
  },
  "Asia/Katmandu": {
    "desc": "NPT",
    "gmt": "GMT+5:45"
  },
  "Asia/Kolkata": {
    "desc": "IST",
    "gmt": "GMT+5:30"
  },
  "Asia/Krasnoyarsk": {
    "desc": "KRAT",
    "gmt": "GMT+7:00"
  },
  "Asia/Kuala_Lumpur": {
    "desc": "MYT",
    "gmt": "GMT+8:00"
  },
  "Asia/Kuching": {
    "desc": "MYT",
    "gmt": "GMT+8:00"
  },
  "Asia/Kuwait": {
    "desc": "AST",
    "gmt": "GMT+3:00"
  },
  "Asia/Macao": {
    "desc": "CST",
    "gmt": "GMT+8:00"
  },
  "Asia/Macau": {
    "desc": "CST",
    "gmt": "GMT+8:00"
  },
  "Asia/Magadan": {
    "desc": "MAGT",
    "gmt": "GMT+11:00"
  },
  "Asia/Makassar": {
    "desc": "CIT",
    "gmt": "GMT+8:00"
  },
  "Asia/Manila": {
    "desc": "PHT",
    "gmt": "GMT+8:00"
  },
  "Asia/Muscat": {
    "desc": "GST",
    "gmt": "GMT+4:00"
  },
  "Asia/Nicosia": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Asia/Novosibirsk": {
    "desc": "NOVT",
    "gmt": "GMT+6:00"
  },
  "Asia/Omsk": {
    "desc": "OMST",
    "gmt": "GMT+6:00"
  },
  "Asia/Oral": {
    "desc": "ORAT",
    "gmt": "GMT+5:00"
  },
  "Asia/Phnom_Penh": {
    "desc": "ICT",
    "gmt": "GMT+7:00"
  },
  "Asia/Pontianak": {
    "desc": "WIT",
    "gmt": "GMT+7:00"
  },
  "Asia/Pyongyang": {
    "desc": "KST",
    "gmt": "GMT+9:00"
  },
  "Asia/Qatar": {
    "desc": "AST",
    "gmt": "GMT+3:00"
  },
  "Asia/Qyzylorda": {
    "desc": "QYZT",
    "gmt": "GMT+6:00"
  },
  "Asia/Rangoon": {
    "desc": "MMT",
    "gmt": "GMT+6:30"
  },
  "Asia/Riyadh": {
    "desc": "AST",
    "gmt": "GMT+3:00"
  },
  "Asia/Riyadh87": {
    "desc": "-",
    "gmt": "GMT+3:07"
  },
  "Asia/Riyadh88": {
    "desc": "-",
    "gmt": "GMT+3:07"
  },
  "Asia/Riyadh89": {
    "desc": "-",
    "gmt": "GMT+3:07"
  },
  "Asia/Saigon": {
    "desc": "ICT",
    "gmt": "GMT+7:00"
  },
  "Asia/Sakhalin": {
    "desc": "SAKT",
    "gmt": "GMT+10:00"
  },
  "Asia/Samarkand": {
    "desc": "UZT",
    "gmt": "GMT+5:00"
  },
  "Asia/Seoul": {
    "desc": "KST",
    "gmt": "GMT+9:00"
  },
  "Asia/Shanghai": {
    "desc": "CST",
    "gmt": "GMT+8:00"
  },
  "Asia/Singapore": {
    "desc": "SGT",
    "gmt": "GMT+8:00"
  },
  "Asia/Taipei": {
    "desc": "CST",
    "gmt": "GMT+8:00"
  },
  "Asia/Tashkent": {
    "desc": "UZT",
    "gmt": "GMT+5:00"
  },
  "Asia/Tbilisi": {
    "desc": "GET",
    "gmt": "GMT+4:00"
  },
  "Asia/Tehran": {
    "desc": "IRST",
    "gmt": "GMT+3:30"
  },
  "Asia/Tel_Aviv": {
    "desc": "IST",
    "gmt": "GMT+2:00"
  },
  "Asia/Thimbu": {
    "desc": "BTT",
    "gmt": "GMT+6:00"
  },
  "Asia/Thimphu": {
    "desc": "BTT",
    "gmt": "GMT+6:00"
  },
  "Asia/Tokyo": {
    "desc": "JST",
    "gmt": "GMT+9:00"
  },
  "Asia/Ujung_Pandang": {
    "desc": "CIT",
    "gmt": "GMT+8:00"
  },
  "Asia/Ulaanbaatar": {
    "desc": "ULAT",
    "gmt": "GMT+8:00"
  },
  "Asia/Ulan_Bator": {
    "desc": "ULAT",
    "gmt": "GMT+8:00"
  },
  "Asia/Urumqi": {
    "desc": "CST",
    "gmt": "GMT+8:00"
  },
  "Asia/Vientiane": {
    "desc": "ICT",
    "gmt": "GMT+7:00"
  },
  "Asia/Vladivostok": {
    "desc": "VLAT",
    "gmt": "GMT+10:00"
  },
  "Asia/Yakutsk": {
    "desc": "YAKT",
    "gmt": "GMT+9:00"
  },
  "Asia/Yekaterinburg": {
    "desc": "YEKT",
    "gmt": "GMT+5:00"
  },
  "Asia/Yerevan": {
    "desc": "AMT",
    "gmt": "GMT+4:00"
  },
  "AST": {
    "desc": "AKST",
    "gmt": "GMT-9:00"
  },
  "Atlantic/Azores": {
    "desc": "AZOT",
    "gmt": "GMT-1:00"
  },
  "Atlantic/Bermuda": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "Atlantic/Canary": {
    "desc": "WET",
    "gmt": "GMT+00:00"
  },
  "Atlantic/Cape_Verde": {
    "desc": "CVT",
    "gmt": "GMT-1:00"
  },
  "Atlantic/Faeroe": {
    "desc": "WET",
    "gmt": "GMT+00:00"
  },
  "Atlantic/Faroe": {
    "desc": "WET",
    "gmt": "GMT+00:00"
  },
  "Atlantic/Jan_Mayen": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Atlantic/Madeira": {
    "desc": "WET",
    "gmt": "GMT+00:00"
  },
  "Atlantic/Reykjavik": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Atlantic/South_Georgia": {
    "desc": "GST",
    "gmt": "GMT-2:00"
  },
  "Atlantic/St_Helena": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Atlantic/Stanley": {
    "desc": "FKT",
    "gmt": "GMT-4:00"
  },
  "Australia/ACT": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Australia/Adelaide": {
    "desc": "CST",
    "gmt": "GMT+9:30"
  },
  "Australia/Brisbane": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Australia/Broken_Hill": {
    "desc": "CST",
    "gmt": "GMT+9:30"
  },
  "Australia/Canberra": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Australia/Currie": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Australia/Darwin": {
    "desc": "CST",
    "gmt": "GMT+9:30"
  },
  "Australia/Eucla": {
    "desc": "CWST",
    "gmt": "GMT+8:45"
  },
  "Australia/Hobart": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Australia/LHI": {
    "desc": "LHST",
    "gmt": "GMT+10:30"
  },
  "Australia/Lindeman": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Australia/Lord_Howe": {
    "desc": "LHST",
    "gmt": "GMT+10:30"
  },
  "Australia/Melbourne": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Australia/North": {
    "desc": "CST",
    "gmt": "GMT+9:30"
  },
  "Australia/NSW": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Australia/Perth": {
    "desc": "WST",
    "gmt": "GMT+8:00"
  },
  "Australia/Queensland": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Australia/South": {
    "desc": "CST",
    "gmt": "GMT+9:30"
  },
  "Australia/Sydney": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Australia/Tasmania": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Australia/Victoria": {
    "desc": "EST",
    "gmt": "GMT+10:00"
  },
  "Australia/West": {
    "desc": "WST",
    "gmt": "GMT+8:00"
  },
  "Australia/Yancowinna": {
    "desc": "CST",
    "gmt": "GMT+9:30"
  },
  "BET": {
    "desc": "BRT",
    "gmt": "GMT-3:00"
  },
  "Brazil/Acre": {
    "desc": "AMT",
    "gmt": "GMT-4:00"
  },
  "Brazil/DeNoronha": {
    "desc": "FNT",
    "gmt": "GMT-2:00"
  },
  "Brazil/East": {
    "desc": "BRT",
    "gmt": "GMT-3:00"
  },
  "Brazil/West": {
    "desc": "AMT",
    "gmt": "GMT-4:00"
  },
  "BST": {
    "desc": "BDT",
    "gmt": "GMT+6:00"
  },
  "Canada/Atlantic": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "Canada/Central": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "Canada/Eastern": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "Canada/East-Saskatchewan": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "Canada/Mountain": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "Canada/Newfoundland": {
    "desc": "NST",
    "gmt": "GMT-3:30"
  },
  "Canada/Pacific": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "Canada/Saskatchewan": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "Canada/Yukon": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "CAT": {
    "desc": "CAT",
    "gmt": "GMT+2:00"
  },
  "CET": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Chile/Continental": {
    "desc": "CLT",
    "gmt": "GMT-4:00"
  },
  "Chile/EasterIsland": {
    "desc": "EAST",
    "gmt": "GMT-6:00"
  },
  "CNT": {
    "desc": "NST",
    "gmt": "GMT-3:30"
  },
  "CST": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "CST6CDT": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "CTT": {
    "desc": "CST",
    "gmt": "GMT+8:00"
  },
  "Cuba": {
    "desc": "CST",
    "gmt": "GMT-5:00"
  },
  "EAT": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "ECT": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "EET": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Egypt": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Eire": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "EST": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "EST5EDT": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "Etc/GMT": {
    "desc": "-",
    "gmt": "GMT+00:00"
  },
  "Etc/GMT-0": {
    "desc": "-",
    "gmt": "GMT+00:00"
  },
  "Etc/GMT-1": {
    "desc": "-",
    "gmt": "GMT+1:00"
  },
  "Etc/GMT-10": {
    "desc": "-",
    "gmt": "GMT+10:00"
  },
  "Etc/GMT-11": {
    "desc": "-",
    "gmt": "GMT+11:00"
  },
  "Etc/GMT-12": {
    "desc": "-",
    "gmt": "GMT+12:00"
  },
  "Etc/GMT-13": {
    "desc": "-",
    "gmt": "GMT+13:00"
  },
  "Etc/GMT-14": {
    "desc": "-",
    "gmt": "GMT+14:00"
  },
  "Etc/GMT-2": {
    "desc": "-",
    "gmt": "GMT+2:00"
  },
  "Etc/GMT-3": {
    "desc": "-",
    "gmt": "GMT+3:00"
  },
  "Etc/GMT-4": {
    "desc": "-",
    "gmt": "GMT+4:00"
  },
  "Etc/GMT-5": {
    "desc": "-",
    "gmt": "GMT+5:00"
  },
  "Etc/GMT-6": {
    "desc": "-",
    "gmt": "GMT+6:00"
  },
  "Etc/GMT-7": {
    "desc": "-",
    "gmt": "GMT+7:00"
  },
  "Etc/GMT-8": {
    "desc": "-",
    "gmt": "GMT+8:00"
  },
  "Etc/GMT-9": {
    "desc": "-",
    "gmt": "GMT+9:00"
  },
  "Etc/GMT+0": {
    "desc": "-",
    "gmt": "GMT+00:00"
  },
  "Etc/GMT+1": {
    "desc": "-",
    "gmt": "GMT-1:00"
  },
  "Etc/GMT+10": {
    "desc": "-",
    "gmt": "GMT-10:00"
  },
  "Etc/GMT+11": {
    "desc": "-",
    "gmt": "GMT-11:00"
  },
  "Etc/GMT+12": {
    "desc": "-",
    "gmt": "GMT-12:00"
  },
  "Etc/GMT+2": {
    "desc": "-",
    "gmt": "GMT-2:00"
  },
  "Etc/GMT+3": {
    "desc": "-",
    "gmt": "GMT-3:00"
  },
  "Etc/GMT+4": {
    "desc": "-",
    "gmt": "GMT-4:00"
  },
  "Etc/GMT+5": {
    "desc": "-",
    "gmt": "GMT-5:00"
  },
  "Etc/GMT+6": {
    "desc": "-",
    "gmt": "GMT-6:00"
  },
  "Etc/GMT+7": {
    "desc": "-",
    "gmt": "GMT-7:00"
  },
  "Etc/GMT+8": {
    "desc": "-",
    "gmt": "GMT-8:00"
  },
  "Etc/GMT+9": {
    "desc": "-",
    "gmt": "GMT-9:00"
  },
  "Etc/GMT0": {
    "desc": "-",
    "gmt": "GMT+00:00"
  },
  "Etc/Greenwich": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Etc/UCT": {
    "desc": "UTC",
    "gmt": "GMT+00:00"
  },
  "Etc/Universal": {
    "desc": "UTC",
    "gmt": "GMT+00:00"
  },
  "Etc/UTC": {
    "desc": "UTC",
    "gmt": "GMT+00:00"
  },
  "Etc/Zulu": {
    "desc": "UTC",
    "gmt": "GMT+00:00"
  },
  "Europe/Amsterdam": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Andorra": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Athens": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Belfast": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Europe/Belgrade": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Berlin": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Bratislava": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Brussels": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Bucharest": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Budapest": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Chisinau": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Copenhagen": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Dublin": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Europe/Gibraltar": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Guernsey": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Europe/Helsinki": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Isle_of_Man": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Europe/Istanbul": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Jersey": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Europe/Kaliningrad": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Kiev": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Lisbon": {
    "desc": "WET",
    "gmt": "GMT+00:00"
  },
  "Europe/Ljubljana": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/London": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Europe/Luxembourg": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Madrid": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Malta": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Mariehamn": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Minsk": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Monaco": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Moscow": {
    "desc": "MSK",
    "gmt": "GMT+3:00"
  },
  "Europe/Nicosia": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Oslo": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Paris": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Podgorica": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Prague": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Riga": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Rome": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Samara": {
    "desc": "SAMT",
    "gmt": "GMT+4:00"
  },
  "Europe/San_Marino": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Sarajevo": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Simferopol": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Skopje": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Sofia": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Stockholm": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Tallinn": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Tirane": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Tiraspol": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Uzhgorod": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Vaduz": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Vatican": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Vienna": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Vilnius": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Volgograd": {
    "desc": "VOLT",
    "gmt": "GMT+3:00"
  },
  "Europe/Warsaw": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Zagreb": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Europe/Zaporozhye": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "Europe/Zurich": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "GB": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "GB-Eire": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "GMT": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "GMT0": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Greenwich": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "Hongkong": {
    "desc": "HKT",
    "gmt": "GMT+8:00"
  },
  "HST": {
    "desc": "HST",
    "gmt": "GMT-10:00"
  },
  "Iceland": {
    "desc": "GMT",
    "gmt": "GMT+00:00"
  },
  "IET": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "Indian/Antananarivo": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "Indian/Chagos": {
    "desc": "IOT",
    "gmt": "GMT+6:00"
  },
  "Indian/Christmas": {
    "desc": "CXT",
    "gmt": "GMT+7:00"
  },
  "Indian/Cocos": {
    "desc": "CCT",
    "gmt": "GMT+6:30"
  },
  "Indian/Comoro": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "Indian/Kerguelen": {
    "desc": "TFT",
    "gmt": "GMT+5:00"
  },
  "Indian/Mahe": {
    "desc": "SCT",
    "gmt": "GMT+4:00"
  },
  "Indian/Maldives": {
    "desc": "MVT",
    "gmt": "GMT+5:00"
  },
  "Indian/Mauritius": {
    "desc": "MUT",
    "gmt": "GMT+4:00"
  },
  "Indian/Mayotte": {
    "desc": "EAT",
    "gmt": "GMT+3:00"
  },
  "Indian/Reunion": {
    "desc": "RET",
    "gmt": "GMT+4:00"
  },
  "Iran": {
    "desc": "IRST",
    "gmt": "GMT+3:30"
  },
  "Israel": {
    "desc": "IST",
    "gmt": "GMT+2:00"
  },
  "IST": {
    "desc": "IST",
    "gmt": "GMT+5:30"
  },
  "Jamaica": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "Japan": {
    "desc": "JST",
    "gmt": "GMT+9:00"
  },
  "JST": {
    "desc": "JST",
    "gmt": "GMT+9:00"
  },
  "Kwajalein": {
    "desc": "MHT",
    "gmt": "GMT+12:00"
  },
  "Libya": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "MET": {
    "desc": "MET",
    "gmt": "GMT+1:00"
  },
  "Mexico/BajaNorte": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "Mexico/BajaSur": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "Mexico/General": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "Mideast/Riyadh87": {
    "desc": "-",
    "gmt": "GMT+3:07"
  },
  "Mideast/Riyadh88": {
    "desc": "-",
    "gmt": "GMT+3:07"
  },
  "Mideast/Riyadh89": {
    "desc": "-",
    "gmt": "GMT+3:07"
  },
  "MIT": {
    "desc": "WST",
    "gmt": "GMT-11:00"
  },
  "MST": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "MST7MDT": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "Navajo": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "NET": {
    "desc": "AMT",
    "gmt": "GMT+4:00"
  },
  "NST": {
    "desc": "NZST",
    "gmt": "GMT+12:00"
  },
  "NZ": {
    "desc": "NZST",
    "gmt": "GMT+12:00"
  },
  "NZ-CHAT": {
    "desc": "CHAST",
    "gmt": "GMT+12:45"
  },
  "Pacific/Apia": {
    "desc": "WST",
    "gmt": "GMT-11:00"
  },
  "Pacific/Auckland": {
    "desc": "NZST",
    "gmt": "GMT+12:00"
  },
  "Pacific/Chatham": {
    "desc": "CHAST",
    "gmt": "GMT+12:45"
  },
  "Pacific/Easter": {
    "desc": "EAST",
    "gmt": "GMT-6:00"
  },
  "Pacific/Efate": {
    "desc": "VUT",
    "gmt": "GMT+11:00"
  },
  "Pacific/Enderbury": {
    "desc": "PHOT",
    "gmt": "GMT+13:00"
  },
  "Pacific/Fakaofo": {
    "desc": "TKT",
    "gmt": "GMT-10:00"
  },
  "Pacific/Fiji": {
    "desc": "FJT",
    "gmt": "GMT+12:00"
  },
  "Pacific/Funafuti": {
    "desc": "TVT",
    "gmt": "GMT+12:00"
  },
  "Pacific/Galapagos": {
    "desc": "GALT",
    "gmt": "GMT-6:00"
  },
  "Pacific/Gambier": {
    "desc": "GAMT",
    "gmt": "GMT-9:00"
  },
  "Pacific/Guadalcanal": {
    "desc": "SBT",
    "gmt": "GMT+11:00"
  },
  "Pacific/Guam": {
    "desc": "ChST",
    "gmt": "GMT+10:00"
  },
  "Pacific/Honolulu": {
    "desc": "HST",
    "gmt": "GMT-10:00"
  },
  "Pacific/Johnston": {
    "desc": "HST",
    "gmt": "GMT-10:00"
  },
  "Pacific/Kiritimati": {
    "desc": "LINT",
    "gmt": "GMT+14:00"
  },
  "Pacific/Kosrae": {
    "desc": "KOST",
    "gmt": "GMT+11:00"
  },
  "Pacific/Kwajalein": {
    "desc": "MHT",
    "gmt": "GMT+12:00"
  },
  "Pacific/Majuro": {
    "desc": "MHT",
    "gmt": "GMT+12:00"
  },
  "Pacific/Marquesas": {
    "desc": "MART",
    "gmt": "GMT-9:30"
  },
  "Pacific/Midway": {
    "desc": "SST",
    "gmt": "GMT-11:00"
  },
  "Pacific/Nauru": {
    "desc": "NRT",
    "gmt": "GMT+12:00"
  },
  "Pacific/Niue": {
    "desc": "NUT",
    "gmt": "GMT-11:00"
  },
  "Pacific/Norfolk": {
    "desc": "NFT",
    "gmt": "GMT+11:30"
  },
  "Pacific/Noumea": {
    "desc": "NCT",
    "gmt": "GMT+11:00"
  },
  "Pacific/Pago_Pago": {
    "desc": "SST",
    "gmt": "GMT-11:00"
  },
  "Pacific/Palau": {
    "desc": "PWT",
    "gmt": "GMT+9:00"
  },
  "Pacific/Pitcairn": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "Pacific/Ponape": {
    "desc": "PONT",
    "gmt": "GMT+11:00"
  },
  "Pacific/Port_Moresby": {
    "desc": "PGT",
    "gmt": "GMT+10:00"
  },
  "Pacific/Rarotonga": {
    "desc": "CKT",
    "gmt": "GMT-10:00"
  },
  "Pacific/Saipan": {
    "desc": "ChST",
    "gmt": "GMT+10:00"
  },
  "Pacific/Samoa": {
    "desc": "SST",
    "gmt": "GMT-11:00"
  },
  "Pacific/Tahiti": {
    "desc": "TAHT",
    "gmt": "GMT-10:00"
  },
  "Pacific/Tarawa": {
    "desc": "GILT",
    "gmt": "GMT+12:00"
  },
  "Pacific/Tongatapu": {
    "desc": "TOT",
    "gmt": "GMT+13:00"
  },
  "Pacific/Truk": {
    "desc": "TRUT",
    "gmt": "GMT+10:00"
  },
  "Pacific/Wake": {
    "desc": "WAKT",
    "gmt": "GMT+12:00"
  },
  "Pacific/Wallis": {
    "desc": "WFT",
    "gmt": "GMT+12:00"
  },
  "Pacific/Yap": {
    "desc": "TRUT",
    "gmt": "GMT+10:00"
  },
  "PLT": {
    "desc": "PKT",
    "gmt": "GMT+5:00"
  },
  "PNT": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "Poland": {
    "desc": "CET",
    "gmt": "GMT+1:00"
  },
  "Portugal": {
    "desc": "WET",
    "gmt": "GMT+00:00"
  },
  "PRC": {
    "desc": "CST",
    "gmt": "GMT+8:00"
  },
  "PRT": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "PST": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "PST8PDT": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "ROK": {
    "desc": "KST",
    "gmt": "GMT+9:00"
  },
  "Singapore": {
    "desc": "SGT",
    "gmt": "GMT+8:00"
  },
  "SST": {
    "desc": "SBT",
    "gmt": "GMT+11:00"
  },
  "SystemV/AST4": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "SystemV/AST4ADT": {
    "desc": "AST",
    "gmt": "GMT-4:00"
  },
  "SystemV/CST6": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "SystemV/CST6CDT": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "SystemV/EST5": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "SystemV/EST5EDT": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "SystemV/HST10": {
    "desc": "HST",
    "gmt": "GMT-10:00"
  },
  "SystemV/MST7": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "SystemV/MST7MDT": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "SystemV/PST8": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "SystemV/PST8PDT": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "SystemV/YST9": {
    "desc": "AKST",
    "gmt": "GMT-9:00"
  },
  "SystemV/YST9YDT": {
    "desc": "AKST",
    "gmt": "GMT-9:00"
  },
  "Turkey": {
    "desc": "EET",
    "gmt": "GMT+2:00"
  },
  "UCT": {
    "desc": "UTC",
    "gmt": "GMT+00:00"
  },
  "Universal": {
    "desc": "UTC",
    "gmt": "GMT+00:00"
  },
  "US/Alaska": {
    "desc": "AKST",
    "gmt": "GMT-9:00"
  },
  "US/Aleutian": {
    "desc": "HAST",
    "gmt": "GMT-10:00"
  },
  "US/Arizona": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "US/Central": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "US/Eastern": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "US/East-Indiana": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "US/Hawaii": {
    "desc": "HST",
    "gmt": "GMT-10:00"
  },
  "US/Indiana-Starke": {
    "desc": "CST",
    "gmt": "GMT-6:00"
  },
  "US/Michigan": {
    "desc": "EST",
    "gmt": "GMT-5:00"
  },
  "US/Mountain": {
    "desc": "MST",
    "gmt": "GMT-7:00"
  },
  "US/Pacific": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "US/Pacific-New": {
    "desc": "PST",
    "gmt": "GMT-8:00"
  },
  "US/Samoa": {
    "desc": "SST",
    "gmt": "GMT-11:00"
  },
  "UTC": {
    "desc": "UTC",
    "gmt": "GMT+00:00"
  },
  "VST": {
    "desc": "ICT",
    "gmt": "GMT+7:00"
  },
  "W-SU": {
    "desc": "MSK",
    "gmt": "GMT+3:00"
  },
  "WET": {
    "desc": "WET",
    "gmt": "GMT+00:00"
  },
  "Zulu": {
    "desc": "UTC",
    "gmt": "GMT+00:00"
  }
};

export const luxonNow = () => Luxon.DateTime.now();

export const luxonClone = (luxon) => Luxon.DateTime.fromMillis(luxon.toMillis());

export const luxonDiffDay = (start, end) => {
  const { days } = end.diff(start, ['days']);
  return Math.sign(days) * Math.floor(Math.abs(days));
}

export const fromFormat = (str, format) => {
  return Luxon.DateTime.fromFormat(str, format);
}

export const fromTimestamp = (timestamp) => {
  return Luxon.DateTime.fromTimestamp(timestamp);
}